<!--大体图组件-->
<template>
  <div
    class="generalWrapper"
    v-bind:style="{'background': isShowBg ? '#61a2bf' : '','color': isShowBg ? '#fff' : '' }"
    @mouseenter="showOption"
    @mouseleave="hideOption"
    @contextmenu.prevent
    :key="id"
    v-loading="showLoadingIcon"
    element-loading-text="正在上传"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.6)"
    style="user-select: none"
  >
    <div class="print-icon iconfont" v-show="isShowBg">&#xe608;</div>
    <div class="ai-icon" v-show="isShowBorder">AI</div>
    <div class="image-box">
      <img
        :src="imgSrcShow"
        :id="Math.random()"
        class="image"
        draggable="true"
        @dragstart="dragStart"
        @click="addReportImgs($event)"
        @load="imgOnload"
      />
    </div>
    <!--<div
      :style="`background-image: url(${imgSrc})`"
      :id="Math.random()"
      class="image"
      @click="addReportImgs($event)"
    ></div>-->
    <template v-if="!!position || type === 1">
      <div style="display:flex;align-items:center;justify-content:space-between;">
        {{position}}
        <span
          v-if="type === 1"
          class="wd-btn"
          :class="{'wd-btn-active': origin === 'WOOD'}"
          style="margin-left:8px;"
          @click.stop="toggleWoodLamp"
          title="标记/取消伍德灯"
        >WD</span>
      </div>
    </template>
    <div class="iconWrapper" v-show="false">
      <img
        src="../assets/love.png"
        width="7%"
        height="auto"
        class="icon"
        @click="collect($event)"
        v-show="!tagged"
      />
      <img
        src="../assets/love_fill.png"
        width="7%"
        height="auto"
        class="icon"
        @click="cancelCollect($event)"
        v-show="tagged"
      />
      <img
        src="../assets/delete.png"
        width="7%"
        height="auto"
        class="icon"
        @click="deleteImg($event)"
      />
      <img src="../assets/editor.png" width="7%" height="auto" class="icon" @click="editor($event)" />
    </div>
    <div class="icon-wrapper" v-show="showIcon">
      <div class="menu-btn" @click.stop="showThisPic">
        <div class="screen-icon iconfont">&#xe6e0;</div>
      </div>
      <div class="menu-btn" @click.stop="deleteImage(item)" v-if="type==2||type==4">
        <span
          class="ai-text"
          v-show="!isShowBorder && (type==2||type==4)"
          @click.stop="activeItem"
        >AI</span>
        <span
          class="ai-text"
          style="color: rgb(179, 26, 16);"
          v-show="isShowBorder && (type==2||type==4)"
          @click.stop="activeItem"
        >AI</span>
      </div>
      <div class="menu-btn" @click.stop="deleteImg($event)">
        <img class="delete-icon" src="../assets/delete.png" alt />
      </div>
      <div class="menu-btn" @click.stop="editor($event)">
        <div class="screen-icon iconfont">&#xe630e;</div>
      </div>
      <div class="menu-btn">
        <img
          class="love-icon"
          src="../assets/love.png"
          alt
          v-show="!tagged"
          @click.stop="collect($event)"
        />
        <img
          class="love-icon"
          src="../assets/love_fill.png"
          alt
          v-show="tagged"
          @click.stop="cancelCollect($event)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import csrfToken from "../getToken";
import api from "../api.ts";
import { mapGetters, mapMutations } from "vuex";
import gql from "graphql-tag";
import _ from "lodash";
// 定义一个时间，当第一张皮肤镜上传后2s内没有底二张就开始搜图，如果有就搜两张
let timer;
export default {
  props: {
    imgSrcShow:String,
    imgSrc: String,
    type: Number,
    index: Number,
    id: Number,
    position: String,
    origin: String,
    isPrint: Boolean,
    arrayList: {
      type: Array,
      default: () => []
    },
    showLoadingIcon: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      menuLeft: "",
      menuTop: "",
      // 是否显示AI搜图图标
      isShowBorder: false,
      isShowBg: false,
      borderObj: {
        border: "5px solid blue"
      },
      imgWidth: 0,
      imgHeight: 0,
      // 显示编辑图片相关图标
      showIcon: false,
      // 收藏
      tagged: false
    };
  },
  computed: {
    ...mapGetters(["getItImgArr"])
  },
  watch: {
    imgSrc() {
      this.activeItem2();
    }
  },
  created() {
    // console.log("position is ",this.position);
  },
  methods: {
    imgOnload(e) {
      const tag = e.target;
      if (tag.width / tag.height >= 140 / 130) {
        const height = tag.height;
        const width = tag.width;
        const countWidth = width / (height / 130);
        e.srcElement.style.height = "130px";
        e.srcElement.style.width = countWidth + "px";
        const s = (countWidth - 140) / 2;
        e.srcElement.style.marginLeft = "-" + s + "px";
      } else {
        const height = tag.height;
        const width = tag.width;
        const countHeight = height / (width / 140);
        e.srcElement.style.width = "140px";
        e.srcElement.style.height = countHeight + "px";
        const s = (countHeight - 130) / 2;
        e.srcElement.style.marginLeft = 0;
        e.srcElement.style.marginTop = "-" + s + "px";
      }
    },
    // 查看单张大图
    showThisPic() {
      this.$emit("showThisPic", this.imgSrc.split("thumbnails/")[1]);
    },
    // 显示删除图片，编辑图片等等操作
    showOption() {
      if (!this.showLoadingIcon) {
        this.showIcon = true;
      }
    },
    // 隐藏删除图片，编辑图片等操作
    hideOption() {
      this.showIcon = false;
    },
    // 收藏该图片
    async collect(event) {
      event.cancelBubble = true;
      // console.log("收藏的图片的id是：",this.id);
      try {
        let collectRes = await this.$apollo.mutate({
          mutation: gql`
            mutation($id: Int!, $tagged: Int) {
              modifyImage(id: $id, tagged: $tagged)
            }
          `,
          variables: {
            id: this.id,
            tagged: 1
          }
        });
        // console.log("collectRes is ",collectRes);
        this.tagged = true;
        this.$message({
          type: "success",
          message: "收藏该图片成功"
        });
      } catch (e) {
        this.$message.error("收藏该图片失败");
      }
    },
    // 取消收藏
    async cancelCollect(event) {
      event.cancelBubble = true;
      // console.log("收藏的图片的id是：",this.id);
      try {
        let collectRes = await this.$apollo.mutate({
          mutation: gql`
            mutation($id: Int!, $tagged: Int) {
              modifyImage(id: $id, tagged: $tagged)
            }
          `,
          variables: {
            id: this.id,
            tagged: 0
          }
        });
        // console.log("collectRes is ",collectRes);
        this.tagged = false;
        this.$message({
          type: "success",
          message: "取消收藏成功"
        });
      } catch (e) {
        this.$message.error("取消收藏失败");
      }
    },
    // 自适应图片
    adaptImage(url, divwidth, divheight) {
      let self = this;
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.src = url;
        img.onload = () => {
          let width = img.width;
          let height = img.height;
          if (width / height < divwidth / divheight) {
            img.height = divheight;
            img.width = (width * divheight) / height;
          } else {
            img.width = divwidth;
            img.height = (height * divwidth) / width;
          }
          self.imgWidth = img.width;
          self.imgHeight = img.height;
          // console.log(img.width);
          // console.log(img.height);
          resolve();
        };
      });
    },
    // ...mapMutations["pushItImgArr","popItImgArr"],
    // 选择要智能搜图的图片  绑定isShowBorder
    /* v-bind:style="{'background': isShowBorder&&(type==2||type==4 )? '#61a2bf' : '','color': isShowBorder&&(type==2||type==4) ? '#fff' : '' }" */
    activeItem() {
      if (this.type === 2 || this.type === 4) {
        // console.log(this.$store.state.chooseItImgArr)
        if (this.isShowBorder) {
          if (this.$store.state.chooseItImgArr.length <= 3) {
            // 出栈操作
            this.$store.commit("popItImgArr", {
              id: this.id,
              src: this.imgSrc
            });
            this.isShowBorder = !this.isShowBorder;
            console.log(this.$store.state.chooseItImgArr)
          }
        } else {
          // console.log(this.$store.state.chooseItImgArr)
          if (this.$store.state.chooseItImgArr.length >= 3) {
            // console.log("@@@@@@@choosed three images already");
            this.$message.error("最多选择三张图片!");
          } else {
            this.isShowBorder = true;
            this.$store.commit("pushItImgArr", {
              src: this.imgSrc,
              id: this.id
            });
          }
        }
      }
    },
    activeItem2() {
      if (this.type === 2 || this.type === 4) {
        if (this.isShowBorder) {
          // if (this.$store.state.chooseItImgArr.length <= 3) {
          // 出栈操作
          this.$store.commit("popItImgArr", {
            id: this.id
          });
          this.$store.commit("pushItImgArr", {
            src: this.imgSrc,
            id: this.id
          });
          // this.isShowBorder = !this.isShowBorder;
          // }
        }
      }
      // console.log(this.$store.state.chooseItImgArrSkin);
      let newImg = _.find(this.$store.state.chooseItImgArrSkin, item => {
        return item.id === this.id;
      });
      // console.log(newImg)
      if (newImg) {
        this.isShowBg = true;
      } else {
        this.isShowBg = false;
      }
    },
    // 删除图片
    deleteImg(event) {
      event.cancelBubble = true;
      this.$emit("opration", { type: "delete", delete: true, id: this.id });
      this.isShowBg = false;
      this.$emit("deleteReportImage");
      this.$store.commit("popItImgArSkin", {
        src: this.imgSrc,
        id: this.id
      });
    },
    editor(event) {
      event.cancelBubble = true;
      // console.log("编辑的图片id 是： ",this.id);
      // let type = 0;
      // switch(this.type) {
      //     case "皮肤镜":
      //         type = 1;
      //         break;
      //     case "大体图":
      //         type = 0;
      //         break;
      //     case "CT":
      //         type = 3;
      //         break;
      //     case "B超":
      //         type = 4;
      //         break;
      //     case "病理":
      //         type = 5;
      //         break;
      // }
      this.$store.commit("setEditStatus", true);
      this.$store.commit("setEditimgId", this.id);
      // 编辑图片包括放大缩小等操作
      this.$emit("opration", {
        type: "editor",
        editor: true,
        imgSrc: this.imgSrc,
        id: this.id,
        idType: this.type,
        index: this.index,
        position: this.position
      });
    },
    dragStart(event) {
      event.preventDefault();
      // console.log("拖动开始");
      // event.dataTransfer.setData("Text", event.target.currentSrc);
      // this.$emit("drag", event);
    },
    addReportImgs(event) {
      // console.log("双击的事件是：",event);
      if (!this.isShowBg) {
        let newList = this.$store.state.chooseItImgArrSkin;
        if (newList.length < 6) {
          this.isShowBg = true;
          this.$emit("addRepImg", event);
          // console.log('部位是',this.position)
          // console.log('event',event)
          this.$store.commit("pushItImgArrSkin", {
            src: this.imgSrc,
            id: this.id
          });
        } else {
          this.$message("最多打印6张影像");
        }
      } else {
        this.isShowBg = false;
        this.$emit("deleteReportImage");
        this.$store.commit("popItImgArSkin", {
          src: this.imgSrc,
          id: this.id
        });
      }
      // console.log()
    },
    // 切换伍德灯标记
    async toggleWoodLamp() {
      const newOrigin = this.origin === 'WOOD' ? '' : 'WOOD';
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation($id: Int!, $origin: String) {
              modifyImage(id: $id, origin: $origin)
            }
          `,
          variables: {
            id: this.id,
            origin: newOrigin
          }
        });
        this.$emit('toggleWoodLamp', { id: this.id, origin: newOrigin });
        this.$message.success(newOrigin === 'WOOD' ? '已标记为伍德灯图片' : '已取消伍德灯标记');
      } catch (e) {
        this.$message.error('操作失败: ' + (e.message || '未知错误'));
      }
    }
  },
  created() {
    // console.log("id is ",this.id);
    // console.log("type is ",this.type);
  },
  async mounted() {
    if (this.type === 2 || this.type === 4) {
      if (this.index < 2) {
        if (this.id && this.imgSrc) {
          if (this.arrayList.length === 1) {
            this.activeItem();
            this.$emit("intelligentSearch");
          } else if (this.arrayList.length >= 2) {
            this.activeItem();
            if (this.index === 1) {
              this.$emit("intelligentSearch");
            }
          }
        }
      }
    }
    if (this.isPrint) {
      this.isShowBg = true;
    }
    // console.log("我渲染完成了")
    let adaptImgWidth = 134;
    let adaptImgHeight = 100;
    // console.log("屏幕分辨率的高是：",window.screen.height);
    // console.log("屏幕分辨率的高是：",window.screen.width);
    if (window.screen.height === 768 && window.screen.width === 1366) {
      adaptImgWidth = 100;
      adaptImgHeight = 75;
    }
    // await this.adaptImage(this.imgSrc,adaptImgWidth,adaptImgHeight);
  }
};
</script>
<style lang="less" scoped>
.generalWrapper,
.header-con,
.iconWrapper {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}
.generalWrapper {
  position: relative;
  background: #fff;
  padding: 2px 2px 2px;
  width: 140px;
  height: 150px;
  font-size: 14px;
  margin-right: 10px;
  margin-bottom: 5px;
  box-shadow: 1px 1px 10px grey;
  cursor: pointer;
  .image-box {
    width: 140px;
    height: 130px;
    overflow: hidden;
    .image {
    }
  }

  .print-icon {
    position: absolute;
    right: 2px;
    bottom: 0;
    color: #fff;
    font-size: 20px;
  }
  .ai-icon {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 2px;
    bottom: 2px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    color: #fff;
    background-color: rgb(179, 26, 16);
    font-size: 12px;
  }
  .wd-btn {
    display: inline-block;
    position: absolute;
    right: 0;
    padding: 0 4px;
    font-size: 11px;
    line-height: 16px;
    border-radius: 3px;
    color: #fff;
    background-color: #ccc;
    cursor: pointer;
    user-select: none;
    vertical-align: middle;
  }
  .wd-btn-active {
    background-color: #9b59b6;
  }
  .wd-btn:hover {
    opacity: 0.85;
  }
}

.iconWrapper {
  position: absolute;
  right: 5px;
  top: 5px;
  justify-content: flex-end;
  flex-direction: row;
}
.typeWrapper {
  white-space: nowrap;
  font-size: 14px;
}
.icon {
  cursor: pointer;
  padding: 5px;
  background: #fff;
  border: 1px solid #fff;
  box-shadow: 2px 2px 10px grey;
  margin-left: 5px;
  opacity: 0.8;
}
.header-con {
  flex-direction: row;
  width: 100%;
  margin-bottom: 5px;
}
// @media screen and (min-width: 1366px){
//   .generalWrapper{
//       width:90px;
//       height: 85px;
//       font-size: 10px;
//   }
// }

.isWidth {
  width: 140px;
  height: auto;
}
.isHeight {
  height: 128px;
  width: auto;
}
.icon-wrapper {
  position: absolute;
  display: flex;
  left: 0;
  top: 0;
  margin-top: 3px;
  margin-left: 3px;
  .menu-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 26px;
    height: 28px;
    background-color: #ebebeb;
    border-radius: 5px;
    background-color: rgba(240, 240, 240, 0.9);
    cursor: pointer;
    user-select: none;
    .screen-icon {
      color: #1296db;
      font-size: 20px;
    }
    .delete-icon {
      width: 25px;
      height: 24px;
    }
    .love-icon {
      width: 24px;
      height: 25px;
    }
    .ai-text {
      color: rgb(64, 165, 219);
      font-size: 23px;
    }
  }
  .menu-btn + .menu-btn {
    margin-left: 2px;
  }
  .menu-btn:hover {
    background-color: #ccc;
  }
}
</style>


